import axios from "axios";

import { IExternalListPage } from "../../types/api";

export interface IInstaMartResult {
    id: string;
    configId: string;
    pincode: string;
    available: boolean;
    inStock: boolean;
    scrapedAt: string;
    createdAt: string;
}

export interface IInstaMartConfig {
    id: string;
    variantId: string;
    skuId: string;
    productId: string;
    createdAt: string;
    deletedAt: string | null;
}

export interface IGetInstaMartResultsParameters {
    limit: number;
    cursor?: string;
    direction?: string;
    skuId?: string;
    pincode?: string;
    startDate?: string;
    endDate?: string;
    token: string;
}

export interface IGetInstaMartConfigsParameters {
    limit: number;
    cursor?: string;
    direction?: string;
    token: string;
}

export interface IGetSkuIdsParameters {
    token: string;
}

export interface ISkuIdOption {
    skuId: string;
    productId: string;
    variantTitle: string;
}

export class InstaMart {
    static async getResults(
        parameters: IGetInstaMartResultsParameters,
    ): Promise<IExternalListPage<IInstaMartResult>> {
        const {
            token,
            cursor,
            limit,
            direction,
            skuId,
            pincode,
            startDate,
            endDate,
        } = parameters;

        const params = new URLSearchParams();

        if (cursor) {
            params.append("cursor", cursor);
        }

        if (direction) {
            params.append("direction", direction);
        }

        if (limit) {
            params.append("limit", limit.toString());
        }

        if (skuId) {
            params.append("skuId", skuId);
        }

        if (pincode) {
            params.append("pincode", pincode);
        }

        if (startDate) {
            params.append("startDate", startDate);
        }

        if (endDate) {
            params.append("endDate", endDate);
        }

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/instamart/results?${params}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }

    static async getConfigs(
        parameters: IGetInstaMartConfigsParameters,
    ): Promise<IExternalListPage<IInstaMartConfig>> {
        const { token, cursor, limit, direction } = parameters;

        const params = new URLSearchParams();

        if (cursor) {
            params.append("cursor", cursor);
        }

        if (direction) {
            params.append("direction", direction);
        }

        if (limit) {
            params.append("limit", limit.toString());
        }

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/instamart/configs?${params}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }

    static async getDistinctSkuIds(
        parameters: IGetSkuIdsParameters,
    ): Promise<ISkuIdOption[]> {
        const { token } = parameters;

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/instamart/sku-ids`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }
}
